// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__7jU9_","log":"ModalInventoryLogs_log__3S6Gz","date":"ModalInventoryLogs_date__B2WeN","userName":"ModalInventoryLogs_userName__2H3Ki"};